import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { Check, Clock } from "lucide-react";
import { SERVICE_GROUPS, IMAGES } from "@/data/content";

export default function Services() {
  return (
    <>
      <section className="relative pt-40 pb-16 overflow-hidden">
        <div className="absolute inset-0"><img src={IMAGES.hairBlow} alt="" className="w-full h-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-b from-midnight/70 to-midnight" /></div>
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <Label>Salon Menu</Label>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">Services Crafted to Perfection</h1>
          <p className="text-lg text-white/70 mt-6 max-w-2xl mx-auto">Every service is a ritual — designed, delivered and finished with luxury precision.</p>
        </div>
      </section>

      {SERVICE_GROUPS.map((g, gi) => (
        <section key={g.id} id={g.id} className={`py-20 ${gi % 2 ? "bg-royal/20 border-y border-gold/10" : ""}`} data-testid={`service-${g.id}`}>
          <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
            <Reveal className={gi % 2 ? "lg:order-2" : ""}>
              <div className="relative aspect-[4/3] rounded-lg overflow-hidden border border-gold/20"><img src={g.img} alt={g.name} className="w-full h-full object-cover" /></div>
            </Reveal>
            <Reveal delay={0.1} className={gi % 2 ? "lg:order-1" : ""}>
              <Label>0{gi + 1}</Label>
              <h2 className="text-3xl sm:text-4xl tracking-tight mt-3">{g.name}</h2>
              <p className="text-white/70 mt-4 leading-relaxed">{g.desc}</p>
              <p className="flex items-center gap-2 text-gold text-sm mt-4"><Clock size={16} /> Duration: {g.duration}</p>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2.5 mt-6">
                {g.items.map((it) => (
                  <span key={it} className="flex items-center gap-2 text-white/80 text-sm"><Check size={14} className="text-gold shrink-0" />{it}</span>
                ))}
              </div>
              <Link to="/book" className="btn-gold inline-flex mt-8" data-testid={`book-${g.id}`}>Book Now</Link>
            </Reveal>
          </div>
        </section>
      ))}

      <section className="py-24 text-center max-w-3xl mx-auto px-5">
        <Reveal>
          <h2 className="text-4xl sm:text-5xl tracking-tight">Pricing Tailored to You</h2>
          <p className="text-white/70 mt-4">Prices vary by hair length, style & products. Get a personalised quote in seconds.</p>
          <Link to="/book" className="btn-gold inline-flex mt-8" data-testid="services-cta">Get Your Quote</Link>
        </Reveal>
      </section>
    </>
  );
}
